module.exports = __webpack_public_path__ + "static/gs_profile-5016b71089f5e722040be8874ad18203.jpg";